<template>
  <div v-if="!homeScreenStatus && !exerciseCompleted && !gameCompleted" class="game">
    <Slider
      :answer-one="fiveExercises[currentExercise].options[0]"
      :answer-two="fiveExercises[currentExercise].options[1]"
      :answer-three="fiveExercises[currentExercise].options[2]"
      @clicked="submitAnswer"
    />

    <!-- Points & Lives -->
    <div class="game__points">
      <p>Points: {{ playerScore }}</p>
    </div>
    <div class="game__lives">
      <ul>
        <li v-for="life in currentLives" :key="life">
          <img class="life" src="@/assets/practices/fishy_problems/life.svg" alt="life" />
        </li>
        <li v-for="life in maxLives - currentLives" :key="life + 10">
          <img class="life" src="@/assets/practices/fishy_problems/life_dim.svg" alt="life_dim" />
        </li>
      </ul>
    </div>

    <!-- Question -->
    <div class="game__question">
      <p>{{ fiveExercises[currentExercise].question }}</p>
    </div>

    <!-- Game Explanation -->
    <div v-show="explanationStatus" class="game__explanation">
      <div class="game__explanation__container">
        <img src="@/assets/practices/fishy_problems/feedback_incorrect.svg" alt="incorrect" />
        <p>{{ fiveExercises[currentExercise].explanation }}</p>
      </div>
      <button @click="clickContinue">Next</button>
    </div>

    <!-- Continue Button -->
    <button
      v-show="
        this.$store.state.fishyProblems.answerStatus &&
        this.$store.state.fishyProblems.correctStatus &&
        !this.$store.state.fishyProblems.explanationStatus
      "
      class="button-continue"
      @click="clickContinue"
    >
      Next
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import { Howl } from 'howler';
import { setTimeout } from 'timers';
// import lottie from 'lottie-web/build/player/lottie';
import exercises from '@/assets/practices/data/fishy_problems/exercises.json';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Game',
  components: {
    Slider: () => import('@/components/practices/fishy_problems/Slider.vue'),
  },
  data: () => ({
    exercises,
    fiveExercises: [],
    render: 0,
  }),
  computed: {
    ...mapGetters({
      correctStatus: 'fishyProblems/correctStatus',
      currentExercise: 'fishyProblems/currentExercise',
      currentLives: 'fishyProblems/currentLives',
      exerciseCompleted: 'fishyProblems/exerciseCompleted',
      explanationStatus: 'fishyProblems/explanationStatus',
      gameCompleted: 'fishyProblems/gameCompleted',
      homeScreenStatus: 'fishyProblems/homeScreenStatus',
      maxLives: 'fishyProblems/maxLives',
      muteStatus: 'settings/muteStatus',
      playerScore: 'fishyProblems/playerScore',
    }),
  },
  created() {
    this.fiveExercises = this.getRandom(this.exercises, 5);
  },
  methods: {
    checkGameOver() {
      if (
        (this.$store.state.fishyProblems.exerciseCompleted && this.$store.state.fishyProblems.currentLives <= 0) ||
        (this.$store.state.fishyProblems.exerciseCompleted && this.$store.state.fishyProblems.currentExercise >= 4)
      ) {
        this.$store.state.fishyProblems.gameCompleted = true;
      } else {
        this.$store.state.fishyProblems.currentExercise += 1;
      }
    },
    checkMuteStatus(status) {
      if (status) {
        sounds.mute(true);
      } else {
        sounds.mute(false);
      }
    },
    clickContinue() {
      sounds.globalButton.play();
      this.$store.state.fishyProblems.explanationStatus = false;
      this.$store.state.fishyProblems.exerciseCompleted = true;
      this.checkGameOver();
      if (!this.$store.state.fishyProblems.gameCompleted) {
        this.$store.state.fishyProblems.exerciseCompleted = false;
      }
      this.render += 1;
      this.$store.state.fishyProblems.correctStatus = false;
      this.$store.state.fishyProblems.answerStatus = false;
    },
    getRandom(arr, n) {
      const result = new Array(n);
      let len = arr.length;
      const taken = new Array(len);
      if (n > len) throw new RangeError('getRandom: more elements taken than available');
      while (n--) {
        const x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    },
    submitAnswer(answer) {
      sounds.globalButton.play();
      if (this.$store.state.fishyProblems.answerStatus) {
        console.log(`You can't do that right now. GAME`);
      } else if (!this.$store.state.fishyProblems.answerStatus) {
        this.$store.state.fishyProblems.answerStatus = true;
        if (!answer) {
          sounds.globalAnswerIncorrect.play();
          this.$store.state.fishyProblems.currentLives -= 1;
          setTimeout(() => {
            this.$store.state.fishyProblems.explanationStatus = true;
          }, 2000);
        } else {
          console.log('Something went wrong in submit() from Slider component.');
        }
      } else {
        console.log('Something went wrong in submit() from Slider component.');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.game {
  @include flex-center;
  flex-direction: column;

  button {
    @include button(#e9004f, #fff);
    z-index: 3;
  }

  .button-continue {
    bottom: 3vh;
    position: fixed;
  }

  &__points,
  &__lives {
    @include flex-center;
    background-color: #cbfdffbb;
    border: 0.75vh solid white;
    border-radius: 5vw;
    height: 9vh;
    padding: 0 2vw;
    position: absolute;
    top: 2vh;
    z-index: 4;
  }

  &__points {
    color: #000;
    font-size: 3vw;
    font-family: 'VanillaExtractRegular';
    left: 2vw;
  }

  &__lives {
    right: 2vw;

    ul {
      @include flex-center;
      list-style: none;

      li {
        margin: 1vh 1vw;

        .life {
          height: 6vh;
          margin-top: 1vh;
        }
      }
    }
  }

  &__question {
    font-size: 0.85em;
    position: absolute;
    text-align: center;
    top: 17vh;
    width: 95vw;
    z-index: 2;
    line-height: 1.35;
  }

  &__explanation {
    @include flex-center;
    background-color: #000000dd;
    flex-direction: column;
    font-size: 0.85em;
    height: 100vh;
    text-align: center;
    width: 100vw;
    z-index: 3;

    &__container {
      @include flex-center;
      flex-direction: column;
      text-align: center;
      width: 90%;

      * {
        margin: 0.75em;
      }

      img {
        height: 20vh;
        width: 20vh;
      }

      p {
        line-height: 1.35;
      }
    }
  }
}

@media (max-aspect-ratio: 8/5) {
  .game {
    &__points {
      p {
        margin-top: 1vh;
      }
    }

    &__explanation {
      &__container {
        img {
          height: 15vh;
          width: 15vh;
        }
      }
    }
  }
}
</style>
